import * as memory from '@coursera/event-pulse/sdk/pageMemory';

import { getCampaignParameters } from 'bundles/page/lib/event-pulse/sdk/campaign';
import inServerContext from 'bundles/ssr/util/inServerContext';

export const setSearchEventDataInMemory = () => {
  if (!inServerContext) {
    const campaign = getCampaignParameters();
    memory.set({
      segment: 'consumer',
      type: 'search_result_page',
      pagination: {
        pageNumber: 1,
      },
      route: window.location.pathname,
      appName: window.appName,
      baseUrl: window.location.href.split('?')[0],
      query: window.location.search,
      url: window.location.href,
      referrerBaseUrl: document.referrer.split('?')[0],
      referrerUrl: document.referrer,
      ...(campaign.campaignid !== null && {
        semCampaignId: campaign.campaignid ?? undefined,
        semCreativeId: campaign.creativeid ?? undefined,
        semKeyword: campaign.keyword ?? undefined,
        utmCampaign: campaign.utm_campaign ?? undefined,
        utmContent: campaign.utm_content ?? undefined,
        utmMedium: campaign.utm_medium ?? undefined,
        utmSource: campaign.utm_source ?? undefined,
        utmTerm: campaign.utm_term ?? undefined,
      }),
    });
  }
};
